<span matDialogTitle class="editor-dialog">
    <span class="fullscreen-toggle" (click)="close()">
      <mat-icon>fullscreen_exit</mat-icon>
    </span>
</span>
<mat-dialog-content>
  <div [style]="dialogStyle">
    <micro-ace-editor
      [config]= "config"
      [mode]="mode"
      [theme]="theme"
      [style]="style"
      [class]="class"
      [readOnly]="readOnly"
      [disabled]="disabled"
      [required]="required"
      [(text)]="text"
      [canFullscreen]="false"
      [inFullscreen]="true"
    >
    </micro-ace-editor>
  </div>
</mat-dialog-content>
<!--<mat-dialog-actions>-->
<!--  <button mat-raised-button (click)="close()">Close</button>-->
<!--</mat-dialog-actions>-->

<style>
  .editor-dialog {
    position: relative;
    /*transition: all 0.3s ease;*/
  }

  .micro-ace-editor-container.fullscreen {
    /*position: relative;*/
    /*top: 0;*/
    /*left: 0;*/
    /*width: 100%;*/
    /*height: 100vh;*/
    /*z-index: 9999;*/
    /*background-color: white;*/
  }
  .fullscreen-toggle {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 20px;
    background: rgba(128,128, 128, 0.25);
    padding: 4px 4px 0 4px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 10000;
    user-select: none;
  }

</style>
